import React from "react";

function ProjectsComponent() {
    return (
        <div className="text-start">
            Coming soon...
        </div>
    );
}
export default ProjectsComponent;